<template>
	<div class="customer">
			<b-container fluid class="p-0 mt-2">
				<b-card >
				<b-row class="mb-3 mt-3">
					
					<b-col>
						<h6><div class="walletIcon"><b-icon class="ml-1 walletFont" icon="wallet2" aria-hidden="true"></b-icon></div><div class="welletText"><span class="heading">Alluraa Wallet</span><br/><small>Your purse to shop on Alluraa</small></div></h6>
						
						<!-- <p>Hello {{$root.customer_info.custname}} (not {{$root.customer_info.custname}}? <b-link href="/customer/logout">Log out</b-link> )</p>
						<p>Fromt your account dashboard you can view your recent orders, manage your shipping and billing addresses and edit your password and account details.</p> -->
					</b-col>
					<b-col>
						<ul>
						<li>Wallet Balance</li>
						<li class="amountTextColor">{{$root.currency()+$root.tofixed(blance, 2)}}</li>
					</ul>
					</b-col>
				</b-row>
				<hr/>
				<b-card>
					<h6>Wallet Status</h6>
					<b-row class="mt-2 px-3">
								<b-col lg="3" class="text-left">
									<span class="mr-2">Date From</span>
									<b-form-datepicker id="datepicker-from" v-model="datefrom" class="mb-2" placeholder="No date"></b-form-datepicker>
								</b-col>
								<b-col lg="3" class="text-left">
									<span class="mr-2">Date To</span>
									<b-form-datepicker id="datepicker-to" v-model="dateto" class="mb-2" placeholder="No date"></b-form-datepicker>
								</b-col>
								<b-col lg="2" class="text-left">
								
									<b-button pill variant="primary"  @click="initloadWalletExpense()" size="sm" class="mt-4">GO</b-button>
								</b-col>
					</b-row>
					<b-row class="mt-4 px-3">
						<b-col  cols="7" class="text-left">
							<b-table-simple hover small caption-top responsive>
								<!--<caption></caption>-->
								<b-thead head-variant="light">
									<b-tr>
										<b-th >Wallet For</b-th>
										<b-th class="text-right">Total Transfer</b-th>
										<b-th class="text-right">Total Expired</b-th>
										<b-th class="text-right">Available Balance</b-th>
									</b-tr>
								</b-thead> 
								<b-tbody>
									<b-tr>
										<b-th>Seller </b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(sellerData.sellerCr, 2)}}</b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(sellerData.sellerEx, 2)}}</b-th>
										
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(sellerData.sellerBalance, 2)}}</b-th>
									</b-tr>
									<b-tr>
										<b-th>Sales-advisor </b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(agentData.agentCr, 2)}}</b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(agentData.agentEx, 2)}}</b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(agentData.agentBalance, 2)}}</b-th>
									</b-tr>
									<b-tr>
										<b-th>Customer </b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(customerData.customerCr, 2)}}</b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(customerData.customerEx, 2)}}</b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(customerData.customerBalance, 2)}}</b-th>
									</b-tr>
									
							   </b-tbody>
							   <b-tfoot head-variant="light">
									<b-tr style="border-top:1px solid #c6c6c6;background-color: #c6c6c624;">
										<b-th >Row Total</b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(Number(sellerData.sellerCr)+Number(agentData.agentCr)+Number(customerData.customerCr), 2)}}</b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(Number(sellerData.sellerEx)+Number(agentData.agentEx)+Number(customerData.customerEx), 2)}}</b-th>
										<b-th class="text-right">{{$root.currency()+ $root.tofixed(Number(sellerData.sellerBalance)+Number(agentData.agentBalance)+Number(customerData.customerBalance), 2)}}</b-th>
									</b-tr>
								</b-tfoot> 
							</b-table-simple>
						</b-col>
								
					</b-row>
				</b-card>
				<hr/>
				<h6 class="">Transaction History</h6>
				<b-row class="mt-2 walletHistory">
					
					<b-col>
					<!-- <ul>
						<li v-if="transaction.length>0">
						<b-row class="walletAc"  v-for="transactionRor in transaction" :key="transactionRor.id">
							<b-col cols="2">
								<ul class="p-0">
									<li>Trxn.ID</li>
									<li>#{{transactionRor.id}}</li>
									<li><small>{{$moment(transactionRor.cr_date).format('DD-MM-YYYY')}}</small></li>
								</ul>
							</b-col>
							<b-col cols="8">{{transactionRor.cr_descriptions}}</b-col>
							<b-col cols="2">
							<span v-if="loginUserId==transactionRor.cr_user_id">
							+{{$root.currency()+ $root.tofixed(transactionRor.cr_amount, 2)}} 
							</span>
							<span v-else>
							-{{$root.currency()+ $root.tofixed(transactionRor.dr_amount, 2)}} 
							</span>
							</b-col>
							
							</b-row>
							</li>
							<li v-else>
									No transaction found!
							</li>
						 transaction
					</ul> -->
						<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
										<!-- <template v-slot:thead-top="">
											<b-tr>
												<b-th colspan="6"></b-th>
												<b-th variant="secondary" colspan="5" class="text-center">Monthly Information</b-th>
												<b-th colspan="2"></b-th>
											</b-tr>
										</template> -->
							<template v-slot:cell(id)="row">
								<span>#{{row.item.id}}</span>
							</template>
							<template v-slot:cell(cr_date)="row">
								<span>{{$moment(row.value).format('DD-MM-YYYY')}}</span>
							</template>
							<template v-slot:cell(userRole)="row">
								<span v-if="row.value==2">Seller</span>
								<span v-else-if="row.value==3">	Sales-advisor</span>
								<span v-else-if="row.value==4">Customer</span>
								<span v-else>Admin</span>

							</template>
								
								<template v-slot:cell(cr_amount)="row">
										<span v-if="loginUserId==row.item.cr_user_id">
										+{{$root.currency()+ $root.tofixed(row.item.cr_amount, 2)}} 
										</span>
										<span v-else>
										-{{$root.currency()+ $root.tofixed(row.item.dr_amount, 2)}} 
										</span>
								</template>
										<!-- <template v-slot:cell(userStatus)="row">
											<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
											<b-badge pill variant="success" v-else>ACTIVE</b-badge>
										</template>
										<template v-slot:cell(rating)="row">
											<b-form-rating v-model="row.value" inline no-border readonly show-value show-value-max size="sm" variant="primary"></b-form-rating>
										</template>-->
										<!-- <template v-slot:cell(balance)="row">
											<span v-if="loginUserId==row.item.cr_user_id">
											{{blance-row.item.cr_amount}}
											</span>
											<span v-else>
											{{blance+row.item.dr_amount}}
											</span>

										</template> --> 
										
										<template v-slot:cell(actions)="row">
											<span v-if="loginUserId==row.item.cr_user_id">
											Cr
											</span>
											<span v-else>
											Dr
											</span>
											
											<!--<b-button pill variant="primary" class="mr-1" @click="wallet.wallet_key=row.item.wallet_key,noAddwallet=1,paywalletBlance=Number(row.item.total_cr_amount) - Number(row.item.total_dr_amount)" size="sm">Pay</b-button>
											<b-button pill variant="primary" v-if="row.item.role!=1 && $root.chkperm('users','edit')" class="mr-1" @click="showViewModal(row.item, row.index, $event.target)" size="sm">History</b-button>-->
										</template> 
									</b-table>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>

						
					</b-col>
				</b-row>
				

				</b-card>
			</b-container>

	</div>
</template>
<script>

export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
       
	},
	mounted(){
        this.initload();
        this.initloadWalletExpense();
		if(this.$root.customer_info.role==1){
		this.loginUserId=1;
		}else{
		this.loginUserId=this.$root.customer_info.user_id;
		}
	},
	data() {
		return{
			statusSidebar: false,
            modal_data: {
                price: 0,
                special_price: 0
			},
			slide:0,
			related_products: [],
			loginUserId:0,
			walletRecord: [],
			transaction: [],
			blance: 0,
			cr_amount: 0,
			dr_amount: 0,
			//url: this.$root.WEBURL+'customer-orders',
			recordUrl: this.$root.WEBAPI+'walletapi/mywalletTransaction-record',
			walletExpenseUrl: this.$root.WEBAPI+'walletapi/walletExpense',
			records:[],
			fields: [
				{ key: 'id', label: 'Trxn. ID',class:'trxnDate'},
				{ key: 'cr_date', label: 'Trxn. Date',class:'trxnDate'},
				/* { key: 'uniq_id', label: 'Unique ID'}, 
				{ key: 'username', label: 'Username'},
				 { key: 'rating', label: 'Rating'}, */
				{ key: 'cr_descriptions', label: 'Details', class:'textwidth'},
				{ key: 'cr_amount', label: 'Amount',class:'text-center'}, 
				/*{ key: 'secure_code', label: 'Secure Code' },
				{ key: 'total_earning', label: 'Earning', class:'text-right' },
				{ key: 'total_customers', label: 'Customers', class:'text-right' },
				{ key: 'total_cr_amount', label: 'Wallet Balance', class:'text-center' },
				{ key: 'userStatus', label: 'User Status', c },
				{ key: 'balance', label: 'Balance', 'extra': 1, class:'text-right' },*/
				{ key: 'actions', label: 'Status', 'extra': 2, class:'text-left' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			/*wallet Expanses*/
			datefrom: '',
			dateto: '',
			agentData :[],
			customerData :[],
			sellerData  :[],
		};
	},
	methods: {
		burgerMenuSidebar() {
		  this.statusSidebar = !this.statusSidebar;
		},
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.recordUrl, {
                accesskey: self.$session.get('access_key'),
                roleId: self.$root.customer_info.role,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.walletRecord = response.data.result;
					self.blance		=	response.data.result.blance;
					self.cr_amount	=	response.data.result.cr_amount;
					self.dr_amount	=	response.data.result.dr_amount;
					self.transaction	=	response.data.result.transaction;
					
					
					
					self.records =response.data.result.transaction;
					//self.records.options = JSON.parse(self.records.options);
					//self.usersRoles = response.data.result.usersRoles;
					self.loading = false;
					self.totalRows = self.records.length;
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			
			
		},
		initloadWalletExpense(){
			var self = this;
			self.axios.post(self.walletExpenseUrl, {
                accesskey: self.$session.get('access_key'),
                datefrom: self.datefrom,
				dateto: self.dateto,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
				
					//console.log(response.data.result);
					self.agentData  = response.data.result.agentData;
					self.customerData  = response.data.result.customerData;
					self.sellerData  = response.data.result.sellerData;
					

                    /* self.walletRecord = response.data.result;
					self.blance		=	response.data.result.blance;
					self.cr_amount	=	response.data.result.cr_amount;
					self.dr_amount	=	response.data.result.dr_amount;
					self.transaction	=	response.data.result.transaction;
					
					
					
					self.records =response.data.result.transaction;
					//self.records.options = JSON.parse(self.records.options);
					//self.usersRoles = response.data.result.usersRoles;
					self.loading = false;
					self.totalRows = self.records.length;
                    //console.log(self.share_data); */
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
	}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.text-width{
		width:20%;
	}
.col-form-label-sm{
padding:0px;
margin:0px;}
.customer{
	.walletIcon{
		float:left;
		width: 12%;
		.walletFont{
			font-size:50px;
			color:#a437e9;
		}
	}
	.welletText{
			width: 93%;
		.heading{ font-size:23px;}
	}
	.amountTextColor{ color:#a437e9; } 
	
	.walletHistory{
	/* width: 70%; */
    font-size: 14px;
		
		.walletAc{border-top: 1px solid #c6c6c6;
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.walletAp{
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.hlink{
		margin-left:10px;
		color:#a437e9;
		}
	}
	.text-width{
		width:20%;
	}

}

</style>